import React from 'react'
import Label from '../control-label'
import { __, sprintf } from 'StylistParent/i18n';
// import Tooltip from '../../../tooltip'

/* Import CSS */
import './index.scss'

class Select extends React.Component {

	changeValue = ( event ) => {
		// Send value up to the parent component (Control).
		this.props.changeValue( event.target.value )
	}

	render() {
		const { values, value } = this.props;
		return (
			<div>
				<select
					onChange={this.changeValue}
					value={this.props.value}>
					{values.map( ( option, index ) => (
						<option
							value={option.value}
							key={index}
							>{option.label}</option>
					) )}
				</select>
			</div>
		)

	}
}

export default Select;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/select/index.jsx